<template>
  <div class="d-flex flex-nowrap flex-row align-items-center slider-container">
    <el-slider
      class="flex-grow-1"
      :class="readOnly ? 'read-only' : ''"
      :max="maxValue"
      :min="minValue"
      :disabled="readOnly"
      v-model="sliderValue"
    ></el-slider>
    <span class="">{{ sliderValue }}</span>
  </div>
</template>
<script>
/**
 * @class BaseRange
 *
 * @description This component renders a slider input
 */
export default {
  name: 'base-range',
  props: {
    value: {
      type: Number,
      default: 50,
    },
    maxValue: {
      type: Number,
      default: 100,
    },
    minValue: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sliderValue: {
      get() {
        return this.value
      },
      set(value) {
        this.onChange(value)
      },
    },
  },
  methods: {
    onChange(value) {
      this.$emit('form-item-changed', { name: this.name, value })
      this.$emit('input', { target: { value } })
    },
  },
}
</script>

<style lang="scss" scoped>
.el-slider__runway.disabled {
  .el-slider__bar {
    background-color: $light4 !important;
  }
}
.slider-container {
  gap: 10px;
}
</style>
